import { ChangeNames, Configuration } from "../../clients/FirebaseClient/types";

type SummaryType = {
    summary: string;
    title: string;
    type: "twoColumn" | "threeColumn" | "buildingAddress" | "naturalLegal";
};

export type GroupType = {
    title: string;
    summaries?: SummaryType[];
    summary?: SummaryType;
};

type SectionType = {
    title: string;
    type: "value" | "document" | "address";
    groups?: GroupType[];
    isVisible?: (configuration: Configuration) => boolean;
};

type StructureType = {
    sections: SectionType[];
};

export const ReportDefinition: StructureType = {
    sections: [
        {
            title: "Ihr Strom-Netzanschluss",
            type: "value",
            groups: [
                {
                    title: "Maßnahme",
                    summaries: [
                        {
                            summary: ChangeNames.PRODUCT_TYPES,
                            title: "Art der Maßnahme",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_TYPES,
                            title: "Art der Verbrauchsgeräte",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.PRODUCT_CLASSES,
                            title: "Anschlussart",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Netzanschluss Demontage",
                    summaries: [
                        {
                            summary: ChangeNames.REMOVAL_POWER_SUBJECT,
                            title: "Durchzuführende Arbeiten",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.REMOVAL_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK,
                            title: "Eigenleistung Tiefbau",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_RECONSTRUCTION,
                            title: "Wiederbebauung erfolgt?",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_RECONSTRUCTION_PRODUCT_CLASSES,
                            title: "Wiederanschluss für",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_BUILDING_OCCUPATION_CONFIRMATION,
                            title: "Bestätigung vorhanden?",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Gebäudeangaben",
                    summaries: [
                        {
                            summary: ChangeNames.NEW_CONNECTION_BUILDING_TYPES,
                            title: "Gebäudetyp",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_CELLAR,
                            title: "Gebäudeaufbau",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_BUILDING_USAGES,
                            title: "Gebäudenutzung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_CELLAR,
                            title: "Gebäudeaufbau",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_BUILDING_USAGES,
                            title: "Gebäudenutzung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_RECONSTRUCTION_BUILDING_USAGES,
                            title: "Gebäudenutzung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Gebäudeangaben",
                    summaries: [
                        {
                            summary: ChangeNames.INCREASE_BUILDING_USAGES,
                            title: "Gebäudenutzung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Netzzugang",
                    summaries: [
                        {
                            summary: ChangeNames.CHARGER_LOCATION,
                            title: "Standort der Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.CHARGER_PUBLIC_PARKING_USAGES,
                            title: "Nutzung der Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.CHARGER_PRIVATE_PARKING_USAGES,
                            title: "Nutzung der Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.CHARGER_SUPPLY_CONNECTION,
                            title: "Anschluss der Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_BUILDING_USAGE,
                            title: "Gebäudenutzung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Anschlusstechnik",
                    summaries: [
                        {
                            summary: ChangeNames.CHARGER_CONNECTION_EXTERIOR_TYPE,
                            title: "Art des Anschlusses",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.CHARGER_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR,
                            title: "Hausanschlusssäule",
                            type: "twoColumn",
                        },

                        {
                            summary: ChangeNames.CHARGER_ADDITIONAL_ELECTRIC_DEMAND,
                            title: "Zusätzlich benötigte Leistung",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.CHARGER_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK,
                            title: "Eigenleistung Tiefbau",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Leistungsermittlung",
                    summaries: [
                        {
                            summary: ChangeNames.NEW_CONNECTION_GAS_DEMAND,
                            title: "Gasnennwärmeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_HOUSING_UNITS,
                            title: "Anzahl der Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_HOUSING_UNITS,
                            title: "Anzahl der Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_RECONSTRUCTION_HOUSING_UNITS,
                            title: "Anzahl der Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_BUSINESS_DEMAND,
                            title: "Gleichzeitig benötigte Gewerbeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_ELECTRIC_BUSINESS_DEMAND,
                            title: "Gleichzeitig benötigte Gewerbeleistung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_BOILER,
                            title: "Elektrische Warmwasseraufbereitung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP,
                            title: "Wärmeanlage",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM,
                            title: "Speicherheizung, Direktheizung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_HEATING_SYSTEM_V2,
                            title: "Speicherheizung, Direktheizung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_HEAT_PUMP_V2,
                            title: "Wärmepumpe",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_ROOM_COOLING_DEVICE,
                            title: "Gerät zur Raumkühlung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_ELEVATOR,
                            title: "Aufzugsanlage",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_INFEED,
                            title: "Einspeiseanlage",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_SHARED_ELECTRICITY,
                            title: "Allgemeinstrom in Mehrfamilienhäusern",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_SAUNA,
                            title: "Sauna",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER,
                            title: "Ladeeinrichtung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_LOADER_V2,
                            title: "Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ELECTRIC_MISCELLANEOUS,
                            title: "Sonstige Verbraucher",
                            type: "threeColumn",
                        },
                    ],
                },
                {
                    title: "Bestandsermittlung",
                    summaries: [
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_HOUSING_UNITS,
                            title: "Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BUSINESS_DEMAND,
                            title: "Gleichzeitig benötigte Gewerbeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_BOILER,
                            title: "Elektrische Warmwasseraufbereitung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_HEAT_PUMP,
                            title: "Wärmeanlage",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRICAL_ELEVATOR,
                            title: "Aufzugsanlage",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SHARED_ELECTRICITY,
                            title: "Allgemeinstrom in Mehrfamilienhäusern",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_SAUNA,
                            title: "Sauna",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_LOADER,
                            title: "Ladeeinrichtung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_MISCELLANEOUS,
                            title: "Sonstige Verbraucher",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_HOUSE_CONNECTION_FUSE_CAPACITY,
                            title: "Hausanschlusssicherung bekannt?",
                            type: "threeColumn",
                        },
                    ],
                },
                {
                    title: "Bestandsermittlung",
                    summaries: [
                        {
                            summary: ChangeNames.INCREASE_CURRENT_GAS_DEMAND,
                            title: "Gasnennwärmeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_HOUSING_UNITS,
                            title: "Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_BUSINESS_DEMAND,
                            title: "Gleichzeitig benötigte Gewerbeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_BOILER,
                            title: "Elektrische Warmwasseraufbereitung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_HEAT_PUMP,
                            title: "Wärmeanlage",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_ELEVATOR,
                            title: "Aufzugsanlage",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_SHARED_ELECTRICITY,
                            title: "Allgemeinstrom in Mehrfamilienhäusern",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_SAUNA,
                            title: "Sauna",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_LOADER,
                            title: "Ladeeinrichtung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_ELECTRIC_MISCELLANEOUS,
                            title: "Sonstige Verbraucher",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_CURRENT_HOUSE_CONNECTION_FUSE_CAPACITY,
                            title: "Hausanschlusssicherung bekannt?",
                            type: "threeColumn",
                        },
                    ],
                },
                {
                    title: "Leistungsbedarf zukünftig",
                    summaries: [
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_GAS_DEMAND,
                            title: "Gasnennwärmeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_HOUSING_UNITS,
                            title: "Wohneinheiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_BUSINESS_DEMAND,
                            title: "Gleichzeitig benötigte Gewerbeleistung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_BOILER,
                            title: "Elektrische Warmwasseraufbereitung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP,
                            title: "Wärmeanlage",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEAT_PUMP_V2,
                            title: "Wärmepumpe",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_HEATING_SYSTEM,
                            title: "Speicherheizung, Direktheizung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_ROOM_COOLING_DEVICE,
                            title: "Gerät zur Raumkühlung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_ELEVATOR,
                            title: "Aufzugsanlage",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_SHARED_ELECTRICITY,
                            title: "Allgemeinstrom in Mehrfamilienhäusern",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_SAUNA,
                            title: "Sauna",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER,
                            title: "Ladeeinrichtung",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER_V2,
                            title: "Ladeeinrichtung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_EXPECTED_ELECTRIC_MISCELLANEOUS,
                            title: "Sonstige Verbraucher",
                            type: "threeColumn",
                        },
                        {
                            summary: ChangeNames.INCREASE_ADDITIONAL_NOTES,
                            title: "Begründung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Technische Daten Ladeeinrichtung",
                    summaries: [
                        {
                            summary: ChangeNames.CHARGER_CHARGING_STATIONS,
                            title: "Technische Daten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.CHARGER_LOAD_MANAGEMENT,
                            title: "Lastmanagementsystem",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.CHARGER_ELECTRIC_INSTALLATION_AGREEMENT,
                            title: "Installationsbedingungen",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_ELECTRIC_INSTALLATION_AGREEMENT,
                            title: "Installationsbedingungen",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Technische Daten Wärmepumpe und Gerät zur Raumkühlung",
                    summaries: [
                        {
                            summary: ChangeNames.ADJUSTABLE_LOAD_DATA_SHEET_DOWNLOAD,
                            title: "Verbrauchsgeräte",
                            type: "threeColumn",
                        },
                    ],
                },
                {
                    title: "Anschlusstechnik",
                    summaries: [
                        {
                            summary: ChangeNames.NEW_CONNECTION_GAS_FEEDS,
                            title: "Ausführungsvariante für Gas",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_POWER_FEEDS,
                            title: "Ausführungsvariante für Strom",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_EXTERIOR_TYPES,
                            title: "Art des Außenanschlusses",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR,
                            title: "Hausanschlusssäule",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_ROOF_TYPES,
                            title: "Art des Daches",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_BUILDING_INTAKES,
                            title: "Art der Gebäudeeinführung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Netzanschluss Änderung",
                    summaries: [
                        {
                            summary: ChangeNames.MODIFICATION_POWER_FEEDS,
                            title: "Stromnetzanschluss",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_POWER_CABLE,
                            title: "Durchzuführende Arbeiten",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_POWER_OVERHEAD,
                            title: "Durchzuführende Arbeiten",
                            type: "twoColumn",
                        },

                        {
                            summary:
                                ChangeNames.MODIFICATION_POWER_CABLE_JUNCTION_BOX_RELOCATION_DISTANCE,
                            title: "Hausanschlusskasten versetzen",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_POWER_CABLE_RELOCATION_DISTANCE,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_POWER_JUNCTION_BOX_REPLACEMENT_REASON,
                            title: "Austausch Hausanschlusskasten",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.MODIFICATION_POWER_OVERHEAD_ROOF_PILLAR_REASSEMBLY_LOCATION,
                            title: "Montage des Dachständers",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_GAS_RELOCATION_DISTANCE,
                            title: "Leitungslänge bei Umlegung der Gasnetzanschlussleitung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.MODIFICATION_REASON,
                            title: "Begründung",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK,
                            title: "Eigenleistung Tiefbau",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.MODIFICATION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING,
                            title: "Eigenleistung Mauerdurchbruch",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Mehrspartenanschluss",
                    summaries: [
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_DESIRES,
                            title: "Mehrsparte",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_BUILDING_INTAKE_SPECIFICATION,
                            title: "Bauwerksdurchdringung",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_CONTACT_ALLOWED,
                            title: "Kontakterlaubnis",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_VARIANTS,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_BASE_PLATE_HEIGHT,
                            title: "Höhe der Bodenplatte",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR,
                            title: "Montage durch Syna",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_INSTALLATION_FRAME_INSTALLED_BY_DISTRIBUTION_SYSTEM_OPERATOR,
                            title: "Montage durch Syna",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Beschaffenheit der Kellerwand",
                    summaries: [
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_CASING_PIPE_DELIVERED_BY_DISTRIBUTION_SYSTEM_OPERATOR,
                            title: "Futterrohr",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.NEW_CONNECTION_MULTILINE_CELLAR_OUTER_WALL_BUSHING,
                            title: "Wanddurchführung",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Eigenleistungen",
                    summaries: [
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_WALL_BUSHING,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_UNDERGROUND_WORK,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_BASE_PLATE_BUSHING,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_MUST_DO_BASE_PLATE_BUSHING,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_UNDERGROUND_WORK,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_DO_WALL_BUSHING,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_OWN_INSTALLATION_FRAME,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INFUSE_PROVIDED_INSTALLATION_FRAME,
                            title: "",
                            type: "twoColumn",
                        },
                        {
                            summary:
                                ChangeNames.NEW_CONNECTION_MULTILINE_PERSONAL_CONTRIBUTION_MUST_INSTALL_CASING_PIPE,
                            title: "",
                            type: "twoColumn",
                        },
                    ],
                },
                {
                    title: "Sonstiges",
                    summaries: [
                        {
                            title: "Sonstige Informationen",
                            type: "twoColumn",
                            summary: ChangeNames.ADDITIONAL_NOTES,
                        },
                    ],
                },
                {
                    title: "Datenschutz",
                    summaries: [
                        {
                            title: "Datenschutz",
                            type: "twoColumn",
                            summary: ChangeNames.DATA_PROTECTION_AGREEMENT,
                        },
                    ],
                },
                {
                    title: "Nutzungsbedingungen",
                    summaries: [
                        {
                            title: "Nutzungsbedingungen",
                            type: "twoColumn",
                            summary: ChangeNames.TERMS_OF_USE_AGREEMENT,
                        },
                    ],
                },
            ],
        },
        {
            title: "Ihre Dokumente",
            type: "document",
        },
        {
            title: "Adressen",
            type: "address",
            groups: [
                {
                    title: "Baumaßnahme",
                    summary: {
                        summary: "buildingAddress",
                        title: "Baumaßnahmenadresse",
                        type: "buildingAddress",
                    },
                },
                {
                    title: "Auftraggeber / Rechnungsanschrift",
                    summary: {
                        summary: "invoiceRecipient",
                        title: "Auftraggeber",
                        type: "naturalLegal",
                    },
                },
                {
                    title: "Grundstückseigentümer",
                    summary: {
                        summary: "propertyOwner",
                        title: "Grundstückseigentümer",
                        type: "naturalLegal",
                    },
                },
                {
                    title: "Antragsteller",
                    summary: {
                        summary: "applicant",
                        title: "Antragsteller",
                        type: "naturalLegal",
                    },
                },
                {
                    title: "Errichter der Anlage",
                    summary: {
                        summary: "systemConstructor",
                        title: "Errichter der Anlage",
                        type: "naturalLegal",
                    },
                },
            ],
        },
        {
            title: "Termine",
            type: "value",
            isVisible: (configuration) => {
                return (
                    configuration !== undefined &&
                    configuration.state.productTypes !== undefined &&
                    configuration.state.productTypes.state.value.removal
                );
            },
            groups: [
                {
                    title: "Demontage",
                    summaries: [
                        {
                            summary: ChangeNames.REMOVAL_DATE,
                            title: "Demontagedatum",
                            type: "twoColumn",
                        },
                        {
                            summary: ChangeNames.REMOVAL_RECONSTRUCTION_DATE,
                            title: "Wiederbebauungsdatum",
                            type: "twoColumn",
                        },
                    ],
                },
            ],
        },
    ],
};
